export function normalizeBelgianPhoneNumber(phone: string): string {
  if (!phone) return '';
    
  // Remove all non-digit characters to work with a clean slate.
  const digits = phone.replace(/\D/g, '');

  // The core of a Belgian mobile number is a 9-digit sequence starting with '4'.
  // We find the beginning of this sequence.
  const mobilePartIndex = digits.indexOf('4');

  // If '4' is not found, it's not a recognizable Belgian mobile format.
  if (mobilePartIndex === -1) {
    return phone; // Return original to avoid breaking other number types.
  }

  // Extract the potential 9-digit mobile number part.
  const nationalPart = digits.substring(mobilePartIndex);

  // If it has the correct length, we've found our number.
  if (nationalPart.length === 9) {
    return `+32${nationalPart}`;
  }

  // If the length is incorrect, it's an unknown or invalid format.
  return phone;
} 